export default "__VITE_ASSET__1e0168c4__"